'use client'

import { BuilderBlocks } from '@builder.io/react'
import { useState } from 'react'

import { Button } from '@src/components/Button/Button'
import { Dropdown } from '@src/components/SKUSelectorDropdown/Dropdown'
import { useLoadings } from '@src/hooks/useLoadings'
import { useBreakpoints } from '@src/utils/breakpoints.util'

import type { SKUSelectorDropdownProps } from './SKUSelectorDropdownProps'

/**
 * This component has been extracted from SKUSelectorV2. It's been simplified so its more efficient and easier to use.
 */
export function SKUSelectorDropdown(props: SKUSelectorDropdownProps) {
  const { options } = props
  const [selectedSku, setSelectedSku] = useState(options?.[0]?.sku ?? '')
  const isLoading = useLoadings().loadings.isAddingLineItems ?? false
  const breakpoints = useBreakpoints()
  const isMobile = breakpoints.isMobile || breakpoints.isTablet

  const renderDropdown = () => {
    const options = (props.options ?? []).map((option, index) => ({
      sku: option.sku ?? '',
      label: option.label ?? '',
      descriptor: option.descriptor ?? '',
      hasImage: option.hasImage ?? false,
      image: option.image,
      contentTop: (
        <BuilderBlocks
          blocks={option.contentTop}
          parentElementId={props.builderBlock?.id}
          dataPath={`component.dropdown[${index}].contentTop`}
        />
      ),
    }))

    const activeOption = options.find((option) => option.sku === selectedSku)
    return (
      <Dropdown
        dropdownOptions={options}
        activeOption={activeOption}
        selectedSku={selectedSku}
        isLoading={isLoading}
        onChange={setSelectedSku}
        previewAllItems={props.previewAllItems}
      />
    )
  }

  return (
    <div data-testid="sku-selector">
      {renderDropdown()}

      <Button
        className="mt-4"
        isLoading={isLoading}
        variant={props.cta?.variant ?? 'primary'}
        size={isMobile ? 'medium' : 'large'}
        actionName="addItemsToCart"
        addItemsToCart={{
          skus: [{ sku: selectedSku, quantity: 1 }],
          redirectUrl: props.cta?.redirectUrl,
        }}
      >
        {props.cta?.label}
      </Button>
    </div>
  )
}
